module.exports = __webpack_public_path__ + "img/Black Pear Tree.f41fe027.jpg";